import { UpdateEmailTemplatePayload, UpdateEmailTemplateResult } from "tech-health-assessment-sdk/dist";
import { api } from "../../../../../services/core-api-service";

class AdminEmailTemplateCardService {
    public async updateEmailTemplate(emailTemplateId: string, payload: UpdateEmailTemplatePayload): Promise<UpdateEmailTemplateResult> {
        return api.admin.updateEmailTemplate(emailTemplateId, payload)
    }
}

export const service = new AdminEmailTemplateCardService()